module.exports = __webpack_public_path__ + "static/Kuba_2_min-884ffe2471ec488f478443078b42e8e8.jpg";